import React from "react";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}>Resources &</span>{" "}
            <span className={styles.accent2}>Engagement Hub</span>
          </h1>
          <p>
            Discover our comprehensive collection of journals, books,
            proceedings, and DOI papers advancing research excellence
          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`}>
              Browse Publications
            </button>
            <button className={styles.button}>Author Guidelines</button>
          </div>
        </div>
      </div>
    </section>
  );
}
